import {css, CSSResult, html, LitElement, nothing, TemplateResult, unsafeCSS,} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {Messages, Price} from '../../../@types/wishlist.js';
import styles from './price.scss';
import {consume} from '@lit/context';
import {i18nContext} from '../../../scripts/context/i18nContext.js';

@customElement('ents-price')
export class PriceElement extends LitElement {
  @consume({context: i18nContext})
  protected messages!: Messages;

  @property({
    type: Object,
    attribute: 'price',
  }) private price!: Price;

  static get styles(): CSSResult {
    return css`
      ${unsafeCSS(styles)}
    `;
  }

  protected render(): TemplateResult {
    return html`
      <div class="ents-wishlist-price__container">
        <div class="ents-wishlist-price">
          <div
            class="bdk-badge-price"
            size="medium"
            ?sale=${this.price.isReduced}
            aria-label="${this.messages['ents.wishlist.product.price.currentPrice.label']} ${this.price.currentPriceMessage}"
            data-test-ents-wishlist-price="${this.price.isReduced ? 'current-reduced' : 'current'}"
          >
            ${this.price.currentPriceMessage}
          </div>
        </div>
        <div class="ents-wishlist-price__information">
          ${this.renderPriceInformation(false, false, 'unit', this.price.unitPriceMessage)}
          ${this.renderPriceInformation(this.price.strikeThrough, true, 'lowest', this.price.lowestPriceMessage)}
          ${this.price.showOriginalPrice ?
            this.renderPriceInformation(this.price.strikeThrough, true, 'original', this.price.originalPriceMessage) :
            nothing}
        </div>
      </div>
    `;
  }

  private renderPriceInformation(
    strikeThrough: boolean,
    withLabel: boolean,
    type: 'unit' | 'lowest' | 'original',
    price?: string,
  ): TemplateResult | typeof nothing {
    if (!price) {
      return nothing;
    }

    const priceFormatted = type === 'unit' ? `(${price})` : `${price}`;

    return html`
      <div
        class="ents-wishlist-price__${type}-price"
        aria-label="${this.messages[`ents.wishlist.product.price.${type}Price.label`]} ${price}"
        data-test-ents-wishlist-price="${type}"
      >
        ${withLabel ? this.messages[`ents.wishlist.product.price.${type}Price.shortLabel`] : nothing}
        <span class="ents-wishlist-price__value">${strikeThrough ? html`
          <s>${priceFormatted}</s>` : priceFormatted}</span>
      </div>
    `;
  }
}
